export default "__VITE_ASSET__ByFs2hKM__"